import axios from 'axios'
import axiosRetry from 'axios-retry'
import Env from '../Env'

export const serviceApi = axios.create({
  baseURL: Env.WEBAPI_URI,
  timeout: Env.WEBAPI_TIMEOUT_MS
})

axiosRetry(serviceApi, {
  retries: Env.WEBAPI_RETRY,
  retryDelay: axiosRetry.exponentialDelay,
  onRetry: (retryCount, error, requetsConfig) => {
    console.log(`サービスAPIの実行に失敗しました。リトライします… ${retryCount}回目`)
  }
})
